import {
  VERIFY_TOKEN_STARTED,
  VERIFY_USER_REGISTERED,
  VERIFY_TOKEN_END,
  USER_LOGIN_STARTED,
  USER_LOGIN_FAILURE,
  USER_LOGOUT,
  VERIFY_USER_PHONE,
  VERIFY_USER_CODE,
  REGISTERD,
} from "../../utils/stringConsts";

const initialState = {
  token: null,
  user: { name: "", logo: "" },
  isAuthenticated: null,
  unit: "",
  expiredAt: null,
  fullName: null,
  accessToken: null,
  level: null,
  authLoading: true
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_TOKEN_STARTED:
      const { silentAuth } = action.payload;
      return silentAuth ? { ...state, } : initialState;

    case VERIFY_TOKEN_END:
      return { ...state, isAuthenticated: false, authLoading: false, };

    case USER_LOGIN_FAILURE:
      return state;

    case REGISTERD:
      const { accessToken, expiredAt, fullName, level, success } =
        action.payload;
      return {
        ...state,
        authLoading: false,
        isAuthenticated: true,
        accessToken,
        expiredAt,
        fullName,
        level,
      };

    case USER_LOGIN_STARTED:
      return {
        ...state,
        isAuthenticated: true,
        accessToken: action.payload.accessToken,
        expiredAt: action.payload.expiredAt,
        fullName: action.payload.fullName,
      };

    case VERIFY_USER_PHONE:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        fullName: action.payload.fullName,
        expiredAt: action.payload.expiredAt,
        authLoading: false,
        isAuthenticated: true,
      };

    case VERIFY_USER_CODE:
      const { codeValidMessage } = action.payload;
      return {
        ...state,
        codeValidMessage,
        isCode: true,
      };

    case VERIFY_USER_REGISTERED:
      return {
        ...state,
        isCode: false,
        isPassword: false,
      };

    case USER_LOGOUT:
      return { ...initialState, isAuthenticated: false, authLoading: false };

    default:
      return state;
  }
};
